import 'babel-polyfill';

window.jQuery = window.$ = require('jquery');

require('./app');